var _ellipse, _path, _circle, _circle2, _circle3, _circle4, _circle5, _path2, _circle6, _circle7, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 220,
    rx: 130,
    ry: 28,
    stroke: "#38bdf8",
    strokeOpacity: 0.2,
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 175 Q200 55 330 175",
    stroke: "#38bdf8",
    strokeWidth: 2,
    strokeOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 130,
    r: 10,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 85,
    r: 8,
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 68,
    r: 9,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 85,
    r: 8,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 130,
    r: 10,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168 195 Q168 118 200 105 Q232 118 232 195 Q200 208 168 195 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192 168 Q200 176 208 168",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18 Q24 8 34 18",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeOpacity: 0.7,
    transform: "translate(168 88)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18 Q24 8 34 18",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeOpacity: 0.7,
    transform: "translate(198 88)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155 175 Q200 195 245 175",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.05a5d39bd0fba8adc4a88a719b9f7614.svg";
export { ForwardRef as ReactComponent };